import { render, staticRenderFns } from "./ClassInfoBox.vue?vue&type=template&id=4c5f55b2&"
import script from "./ClassInfoBox.vue?vue&type=script&lang=js&"
export * from "./ClassInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./ClassInfoBox.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports